/* eslint-disable react-hooks/exhaustive-deps */
import { default as UUID } from "node-uuid"
import { useEffect, useState } from "react"
import { SCALAR_TYPES } from "src/libs/scalars"
import { showToast } from "src/libs/useful"
import { actions } from "src/modules/pe-landing-module/data/actions"
import { GET_FB_GOODS_ACTION } from "src/modules/pe-landing-module/data/actionTypes"
import { CARD_FIELD_TYPE, CardFiled, FBGoodsContent, FBGoodsFields, ICard, ILanding, ILandingCategory, ILandingSection, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import fb_goods from "src/modules/pe-landing-module/data/utils/fb_goods"
import useCardFieldsOrder from "src/modules/pe-landing-module/hooks/useCardFieldsOrder"
import parseCSV from "../primitive/fb-goods/parseCSV"
import CategoriesFilter from "../useful/CategoriesFilter"
import Cards from "./Cards"
import Dummy from "./Dummy"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { isArraysJoint } from "src/libs/utilities"


/* Protopia Ecosystem component */
export interface IHeaderProps {
    section: ILandingSection
    data: FBGoodsContent 
}

// Dictionary for used card fields type 
export const PersonsFieldType  = ( ): any => { 
    return {
        empty: CARD_FIELD_TYPE.EMPTY,
        canvas: CARD_FIELD_TYPE.CANVAS,
        title: CARD_FIELD_TYPE.TITLE,
        thumbnail : CARD_FIELD_TYPE.IMAGE,
        background : CARD_FIELD_TYPE.IMAGE, 
        person : CARD_FIELD_TYPE.PERSON,
        description : SCALAR_TYPES.HTML,
        content : SCALAR_TYPES.HTML,
        links : CARD_FIELD_TYPE.PERSONAL_LINKS,
        divider : CARD_FIELD_TYPE.DIVIDER,
        statistic_line: CARD_FIELD_TYPE.STATISTIC_LINE, 
        order : CARD_FIELD_TYPE.ORDER,
        category_label: CARD_FIELD_TYPE.CATEGORY_LABEL
    }
}

const FBGoods = ( props: IHeaderProps): JSX.Element => {
    const currentLanding: ILanding      = useLandingStore((state: ILandingStore) => state.currentLanding)
    const [thread, setThread]           = useState<string[]>([])
    const [cards, setCards]              = useState<any[]>([])
    const [categories, setCategories]   = useState<any[]>([])
    const [titleIndex, setTitleIndex]   = useState<number>(0) 
    const [contentIndex, setContentIndex]   = useState<number>(0) 
    const [descriptionIndex, setDescriptionIndex]   = useState<number>(0) 
    const [thumbnailIndex, setThumbnailIndex]   = useState<number>(0) 
    const [isLoading, setIsLoading]   = useState<boolean>(true) 
    
    /* category_name: { category: ILandingCategory, names: string[] } */
    const [filters, setFillters] = useState<any[]>( 
        currentLanding.categories?.map( category => ({ category, names:[] }) ) || [] 
    ) 

    const template = !!props.data.design_type
        ?
        fb_goods()[ props.data.design_type - 1 ]
        :
        {}
    
    const data: FBGoodsContent = {
        ...props.data,
        ...template 
    }
    const { section } = props
    const { card_fields } = data

    useEffect(() => { 
        if(!!data.src) {
            actions(
                GET_FB_GOODS_ACTION,
                {
                    src: data.src
                }
            )
            .then(
                resp => {
                    const parse = parseCSV(resp)
                    setThread(parse.thread)                 
                    setCards(parse.data)                 
                    setCategories(parse.categories)   
                    setTitleIndex(parse.titleIndex)
                    setContentIndex(parse.contentIndex)
                    setDescriptionIndex(parse.descriptionIndex)
                    setThumbnailIndex(parse.thumbnailIndex)
                    setIsLoading(false)
                },
                err => {
                    showToast({
                        message: err.toString()
                    })
                }
            )
        }
    }, [])    
    const order: (keyof FBGoodsFields)[] = useCardFieldsOrder( data.order, card_fields ) as (keyof FBGoodsFields)[]

    if(isLoading) {
        return <></>
    }
    const getCardFieldType = (key: keyof FBGoodsFields)  : CARD_FIELD_TYPE | SCALAR_TYPES => {
        return PersonsFieldType( )[key]
    }
    const getCategory = (key: string) => {
        const currentLanding = useLandingStore.getState().currentLanding
        const landingCategories: ILandingCategory[] = currentLanding.categories || []
        const cat = landingCategories.find(ct => ct.id ===  key) || {} as ILandingCategory 
        // console.log( key, cat) 
        return cat
    }
    const getCardFields = ( card_fields: FBGoodsFields ) : CardFiled[] => {
        let arr: any[] = order.map((key: keyof FBGoodsFields) => { 
            const field: CardFiled = {
                id: UUID.v4(),
                ...card_fields[key],
                type: getCardFieldType(key),
                pseudonym: key,
                category: getCategory(key),
            }
            return field
        })
        return arr
    }
    const filterCard = ( card: any, i:number ) => {
        let bool = true
        // if all filters clear
        if( !filters.filter( f => !!f.names.length).length ) {            
            return true
        }

        // if check some of cards category
        bool = !!filters.filter( f => {
            
            console.log( f.names, card.filter(cf => cf === !!f.names?.length ? f.names[0] : "==")[0] )
            return isArraysJoint(f.names, card)
        }).length
        
        console.log(bool)
        
        return bool
    }
    const getCards = (): ICard[] => {
        let arr: any[] = cards
        .filter(( card: any, i:number ) => filterCard( card, i))
        .map(( card: any, i:number ) => {
            const item : any = {
                i,
                id: card[0],
                value: order.map((o, ii) => {
                    return initCard( card, o, thread, categories, titleIndex, contentIndex, descriptionIndex, thumbnailIndex, data, i ) 
                })
            }
            return item
        })
        return arr
    }
    const getData = ( card_fields: FBGoodsFields ): any => {
        const personalLinkType: any = {
            ...data,
            card_fields: getCardFields( card_fields ),
            gap: 40,
            cards: getCards()
        }
        return personalLinkType
    }
    const onFilter = ( cat: any, items: any ) => {
        const _filters = filters.map(f => {  
            return  f.category.id === cat.name ? { ...f, names: items } : f 
        })
        setFillters( _filters )
    }
    
    return !!Object.keys(order).length
        ?
        <>
            <CategoriesFilter  
                primitive={{
                    ...(data ),
                    height: props.section.height || 70
                } as any }  
                onFilter={ onFilter }
            /> 
            <Cards 
                section={section}
                data={ getData( card_fields || {} ) }
            />
        </>        
        :
        <Dummy {...{ 
            ...{
                data: {
                    ...data as any, 
                    type: LANDING_TYPE_CONTENT.FB_GOODS, 
                    className: ` ${data.className} landing-fb-goods-${props.section.id} `
            },
        }, 
        ...props as any
    }} />       
}
export default FBGoods


export const initCard = ( 
    cardData: any, 
    field: keyof FBGoodsFields, 
    thread: string[], 
    categories: any[], 
    titleIndex: number, 
    contentIndex: number, 
    descriptionIndex: number, 
    thumbnailIndex: number, 
    data: FBGoodsContent, 
    i:number 
): any => {

    switch(field) {
        case "title":
            return {
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
                data: cardData[titleIndex],
            }
        case "thumbnail":
            return {
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
                data: cardData[thumbnailIndex],
            }
        case "description":
            return {
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
                data: cardData[descriptionIndex],
            }
        case "content":
            return {
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
                data: cardData[contentIndex],
            }
        case "background":
            return {
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
                data: cardData[thumbnailIndex],
            }
        default:
            let fieldData: any = { 
                ...data.card_fields[ field ],
                id: cardData[0] + "-" +field + "-" + i,
            }
            const index = thread.findIndex( th => th.indexOf(field) >= 0 )
            if( index > -1 ) {
                fieldData = {
                    ...data.card_fields.category_label,
                    ...fieldData,
                    data : cardData[index],
                    card_field_type: CARD_FIELD_TYPE.CATEGORY_LABEL
                } 
            }
            return fieldData
    }
}
